import React from "react";
import ReactDOM from "react-dom";
import GA4React from "ga-4-react";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { Provider } from "react-redux";
import store from "./store";
const ga4react = new GA4React("G-DG7YBYX1NK");

(async (_) => {
  await ga4react
    .initialize()
    .then()
    .catch((err) => console.error("Analytics Failure."))
    .finally(() => {
      ReactDOM.render(
        <React.StrictMode>
            <BrowserRouter>
              <Provider store={store}>
                <App />
              </Provider>
            </BrowserRouter>
        </React.StrictMode>,
        document.getElementById("root")
      );
    });
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
